import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import RegisterVendor from './components/Vendor/RegisterVendor';
import Login from './components/User/Login';
import HowItWorks from './components/Shared/HowItWorks';
import Terms from './components/Shared/Terms';
import Privacy from './components/Shared/Privacy';
import EarningsEstimator from './components/Shared/EarningsEstimator';
import UploadImage from './components/Customer/UploadAdImage';
import RegistrationSuccess from './components/User/RegistrationSuccess';
import DeviceSummaryPage from './components/Device/DeviceSummary';
import DeviceSummaryDetailsPage from './components/Device/DeviceSummaryDetails';
import Landing from './components/Shared/Landing';
import VerifyEmail from './components/User/VerifyEmail';
import ForgotPassword from './components/User/ForgotPassword';
import ResetPassword from './components/User/ResetPassword';
import JoinWaitlist from './components/Vendor/JoinWaitlist';
import NotFound from './components/Shared/NotFound';
import { customerRoutes } from "./routes/CustomerRoutes";
import { vendorRoutes } from "./routes/VendorRoutes";

export default function AppRoutes({ handleLogin }) {
    return (
        <Routes>
            {customerRoutes}
            {vendorRoutes}
            <Route path="/register/vendor" element={<RegisterVendor />} />
            {/* The front door for broadcasters: sign-up itself is gated on an
                approved waitlist entry. */}
            <Route path="/waitlist" element={<JoinWaitlist />} />
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            {/* Reached from the links in the confirmation and reset emails;
                utils/mailer.py builds them against FRONTEND_BASE_URL. */}
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            {/* Landing.js existed but nothing routed to it -- "/" went
                straight to the browse grid, so the marketing page was
                unreachable. Browse keeps its own path. */}
            <Route path="/" element={<Landing />} />
            <Route path="/upload" element={<UploadImage />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/estimate" element={<EarningsEstimator />} />
            {/* /about was this page's path until it was renamed. Kept as a
                redirect rather than deleted: the link is in the wild -- it was
                the nav's only non-Browse destination -- and a 404 is a worse
                answer than the page they were asking for. `replace` so it does
                not sit in history and trap the back button. */}
            <Route path="/about" element={<Navigate to="/how-it-works" replace />} />
            <Route path="/registration-success" element={<RegistrationSuccess />} />
            <Route path="/devices" element={<DeviceSummaryPage />} />
            <Route path="/devices/:deviceId" element={<DeviceSummaryDetailsPage />} />
            {/* Without this, an unmatched path rendered nothing at all: nav and
                footer in place, empty page between them. A dead link then
                looked like a button that did not work. */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}